//note: code formatted for ES6 here
import React, { Component } from "react";
import { Map, Marker, GoogleApiWrapper } from "google-maps-react";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
var mapKey = ""
export class MapContainer extends Component {
  state = {
    showingInfoWindow: false,
    activeMarker: {},
    selectedPlace: {},
  };
  componentDidMount() {
    let prop = this.props;

  }
  // onMapClicked = (props, marker, e) => {
  //   // let center = marker.center;
  // };

  // onMarkerClick = (props, marker, e) => {
  //   let position = marker.getPosition();
  //   this.setState({ lat: position.lat(), lng: position.lng() });
  // };

  onMarkerDragEnd = (props, marker, e) => {
    let position = marker.getPosition();
    this.props.onMarkerDragEnd(position.lat(), position.lng());
    //this.setState({ lat: position.lat(), lng: position.lng() });
  };

  handleSelect = (address) => {
    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        this.props.selectGoogleAddressPin(address, latLng.lat, latLng.lng);
      })
      .catch((error) => console.error("Error", error));
  };

  render() {
    const searchOptions = {
      componentRestrictions: { country: ["ind"] },
    };
    return (
      <div className="gmap-div">
      <div id="googleMap">
        <div className="adrsmap-hspadmin">
          <Map
            google={this.props.google}
            // onClick={this.onMapClicked}
            initialCenter={{
              lat:
                this.props.latitude === "" || this.props.latitude === undefined || this.props.latitude == 0
                  ? 8.555164446
                  : this.props.latitude,
              lng:
                this.props.longitude === "" ||
                this.props.longitude === undefined || this.props.longitude == 0
                  ? 76.875496498
                  : this.props.longitude,
            }}
            center={{
              lat:
                this.props.latitude === "" || this.props.latitude === undefined || this.props.latitude == 0
                  ? 8.555164446
                  : this.props.latitude,
              lng:
                this.props.longitude === "" ||
                this.props.longitude === undefined || this.props.longitude == 0
                  ? 76.875496498
                  : this.props.longitude,
            }}
          >
            <Marker
              // onClick={this.onMarkerClick}
              name={"Current location"}
              position={{
                lat:
                  this.props.latitude === "" ||
                  this.props.latitude === undefined
                    ? 8.555164446
                    : this.props.latitude,
                lng:
                  this.props.longitude === "" ||
                  this.props.longitude === undefined
                    ? 76.875496498
                    : this.props.longitude,
              }}
              draggable={true}
              onDragend={this.onMarkerDragEnd}
            />
            {/*    
          <InfoWindow
            marker={this.state.activeMarker}
            visible={this.state.showingInfoWindow}>
              <div>
                <h1>{this.state.selectedPlace.name}</h1>
              </div>
          </InfoWindow> */}
          </Map>
        </div>

     
      </div>
      </div>
    );
  }
}

export default GoogleApiWrapper({
  apiKey:process.env.REACT_APP_googleMapKey,
})(MapContainer);
